module.exports = __webpack_public_path__ + "media/byob.959f409e.mp3";